import React, {useEffect, useState} from 'react';
import ObjectDataHolder from "../Hooks/ObjectDataHolder";
import Loader from "../Loader";
import Header from "../Header/Header";
import SellFactorKOL from "../SellFactor/FactorKOL/SellFactorKOL";
import SellFactorJOZ from "../SellFactor/FactorJOZ/SellFactorJOZ";
import AddProductSection from "../SellFactor/FactorJOZ/AddProductSection";
import SaleReturnTable from "./SaleReturnTable";
import {useLocation, useNavigate} from "react-router-dom";
import {BuyReturnData} from "./BuyReturnData";
import {prefixUrl} from "../../utils/utilsData";
import _axios from "../../httpService"
import {toast} from "react-toastify";
import FactorDatePicker from "../FactorDatePicker/FactorDatePicker";
import SellerRLookUp from "./SellerRLookUp";
import SelectTypeSaleReturn from "./SelectTypeSaleReturn";
import numericFunction from "../../utils/NumericFunction";
import TextareaCustom from "../Factor/TextareaCustom";
import FactorRLookUp from "./FactorRLookUp";
import {formatToPersianAddComma, parseToEnRemoveComma} from "../../utils/CommaSeparator";


const BuyReturn = () => {
  const [sendData, setSendData] = ObjectDataHolder();
  const [initialData, setInitialData] = ObjectDataHolder();
  const [componentData, setComponentData] = ObjectDataHolder();
  const [loading, setLoading] = useState(true);
  const [isSubmitButtonActive, setIsSubmitButtonActive] = useState(true)


  const myLocation = useLocation();
  const navigateTo = useNavigate()

  useEffect(() => {


    if (myLocation?.state?.id) {


      const id = myLocation.state.id
      if (!id) {
        toast(" مقدار آیدی تعیین نشده است.")
        return
      }
      _axios.get(prefixUrl() + "/returnFromBuy/?request=buyReturnSubmittedData&buyReturnId=" + id).then(res => {
        const data = res.data;
        if (data.status) {

          setInitialData(data.data.initialData)
          setSendData(data.data.buyReturnData)
          setLoading(false)
        } else {
          toast.error(data.message)
        }
      })

    } else {
      const urlToGetInitialData = prefixUrl() + "/returnFromBuy/?request=initialData";
      _axios.get(urlToGetInitialData).then(res => {
        const data = res.data;
        if (data.status) {
          // setInitialData(SaleReturnData.initialData)
          setInitialData(data.data)
          setSendData(BuyReturnData.sendData)
          setLoading(false)
        } else {
          toast.error("مقادیر دریافتی از سرور به درستی تعیین نشده است.")

        }
      })


    }

  }, [])

  const submitSaleReturnHandler = (e) => {
    e.preventDefault();

    const temp = {...sendData};
    if (temp.sellerId === "") {
      toast.error("لطفا یک فروشنده انتخاب کنید.");
      return
    }
    if (temp.date === "") {
      toast.error("لطفا یک تاریخ انتخاب کنید.");
      return;
    }
    if (temp.tableData.length === 0) {
      toast.error("جدول جزئیات مرجوعی نمیتواند خالی باشد.");
      return;
    }
    temp.date = numericFunction.p2e(temp.date);
    const urlToSendDataToBackEnd = prefixUrl() + "/returnFromBuy/"
    setIsSubmitButtonActive(false)

    _axios.post(urlToSendDataToBackEnd, {
      request: "buyReturnConfirm", buyReturnData: temp
    }).then(res => {
      setIsSubmitButtonActive(true)

      const data = res.data;
      if (data.status) {
        setSendData(BuyReturnData.sendData);
        toast.success(data.message)
        if (sendData.mode === "edit") {
          navigateTo(-1)
        }

      } else {
        toast.error(data.message)
      }
    }).catch(err => {
      console.log(err);
      setIsSubmitButtonActive(true)
    })


  }
  return (<>
    <div className={"factor-component"}
    >
      {loading ? <Loader/> : <>
        {/*  sendData={sendData} setSendData={setSendData} initialData={initialData}*/}
        {/*  componentData={componentData} setComponentData={setComponentData}*/}
        {/*/>*/}
        <>
          <div className="total">

            <h5 className="factor-title">مرجوع از خرید</h5>
            <form>
              <div className="form-control">
                <FactorDatePicker
                  sendData={sendData}
                  setSendData={setSendData}
                  initialData={initialData}
                  componentData={componentData}
                  setComponentData={setComponentData}
                />
              </div>
              <div className="form-control0">
                <SellerRLookUp
                  sendData={sendData}
                  setSendData={setSendData}
                  initialData={initialData}
                  componentData={componentData}
                  setComponentData={setComponentData}
                />
              </div>
              <FactorRLookUp
                sendData={sendData}
                setSendData={setSendData}
                initialData={initialData}
                componentData={componentData}
                setComponentData={setComponentData}
              />

              <input
                type="text"
                className="form-control"
                placeholder="مالیات"
                value={(sendData.tax ? ("درصد مالیات :  " + formatToPersianAddComma(sendData.tax)) : "")}
                disabled={true}

              />

              {/*<SelectTypeSaleReturn*/}
              {/*  sendData={sendData}*/}
              {/*  setSendData={setSendData}*/}
              {/*  initialData={initialData}*/}
              {/*  componentData={componentData}*/}
              {/*  setComponentData={setComponentData}*/}
              {/*/>*/}
              <div className={"form-control"}>
                <TextareaCustom
                  value={sendData.description}
                  onChange={e => setSendData({description: e.target.value})}
                  placeholder={"توضیحات مرجوعی"}

                />
              </div>
              <input
                disabled={!isSubmitButtonActive}

                onClick={submitSaleReturnHandler} type="submit"
                className="btnCustom btnSubmit py-5 mt-5"

                value="ثبت مرجوعی"/>

            </form>
          </div>
          <div className="total">
            <h6 className="factor-title"> جزئیات مرجوع از خرید </h6>
            <AddProductSection
              sendData={sendData}
              setSendData={setSendData}
              initialData={initialData}
              componentData={componentData}
              setComponentData={setComponentData}
              mode={"buyReturn"}
              storeRoomType={"showAll"}
            />
            <SaleReturnTable
              sendData={sendData}
              setSendData={setSendData}
              initialData={initialData}
              componentData={componentData}
              setComponentData={setComponentData}
            />
          </div>
        </>
      </>}


    </div>
  </>);
};

export default BuyReturn;
